// extracted by mini-css-extract-plugin
module.exports = {"OnePicture":"OnePictureDE_OnePicture__SICu_"};